import { gozokiApiWithAuth } from '../gozokiApi'

export interface SensorData {
  id: number
  reference: string | null
  label: string
  description: string
  model: string | null
  fridge: {
    id: number
    reference: string | null
    label: string
    type: string
  } | null
  storeLabel: string
  latestReading: {
    temperature: number
    humidityPercentage: number
    sensorBatteryPercentage: number
    readingTime: string
  } | null
}

// Fetch all sensors with their latest readings
export const fetchSensors = async (storeId?: number | null) => {
  const params = storeId && storeId !== null ? { store: storeId } : {}
  const response = await gozokiApiWithAuth.get<SensorData[]>('/sensors', { params })
  return response.data
}

export interface SensorReading {
  readingTime: string
  temperature: number
  humidityPercentage: number
  sensorBatteryPercentage: number
}

export interface SensorHistoryData {
  sensorId: number
  sensorLabel: string
  equipmentLabel: string
  readings: SensorReading[]
}

export interface FetchSensorHistoryParams {
  storeId?: number | null
  sensorIds?: number[]
  startTime?: Date
  endTime?: Date
}

// Fetch sensor reading history for a time period
export const fetchSensorHistory = async (params: FetchSensorHistoryParams) => {
  const queryParams: Record<string, string | number | number[]> = {}
  if (params.storeId !== null && params.storeId !== undefined) {
    queryParams.store = params.storeId
  }
  if (params.sensorIds && params.sensorIds.length > 0) {
    // Send as array - axios will handle it correctly
    queryParams.sensorIds = params.sensorIds
  }
  if (params.startTime) {
    queryParams.startTime = params.startTime.toISOString()
  }
  if (params.endTime) {
    queryParams.endTime = params.endTime.toISOString()
  }
  const response = await gozokiApiWithAuth.get<SensorHistoryData[]>('/sensors/history', {
    params: queryParams,
  })
  return response.data
}

export interface FridgeData {
  id: number
  reference: string | null
  label: string
  type: string
  description: string
  store: {
    id: number
    checkpointStoreRef: string
    label: string
  } | null
}

// Fetch a single sensor by ID
export const fetchSensor = async (id: number) => {
  const response = await gozokiApiWithAuth.get<SensorData>(`/sensors/${id}`)
  return response.data
}

// Fetch all fridges
export const fetchFridges = async (storeId?: number | null) => {
  const params = storeId && storeId !== null ? { store: storeId } : {}
  const response = await gozokiApiWithAuth.get<FridgeData[]>('/sensors/fridges', { params })
  return response.data
}

// Fetch a single fridge by ID
export const fetchFridge = async (id: number) => {
  const response = await gozokiApiWithAuth.get<FridgeData>(`/sensors/fridges/${id}`)
  return response.data
}
